import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';

import ReadOnlyBlock from '../../../../../../../../components/ReadOnlyBlock';
import { Station } from '../..';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  station: Station;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const StepReview = ({ classes, station, setStep }: Props): React.ReactElement => {
  return (
    <>
      <ReadOnlyBlock
        items={[
          { label: 'Department name', value: station.name },
          { label: 'Phone', value: station.phone || 'No phone number' },
        ]}
        handleEdit={() => setStep(0)}
      />
    </>
  );
};

export default withStyles(styles)(StepReview);
